import { CONTENT_API_BASE_URL } from './utils/constants';

export const environment = {
  inspireApi: 'https://inspire-api.sembo.com/graphql/',
  sanityApi: 'https://inntox6v.apicdn.sanity.io',
  smartSearchApi: 'https://smart-search.sembo.com/graphql',
  productApi: `${CONTENT_API_BASE_URL}/Hotels/GetHotels`,
  // 15 minutes
  revalidate: 60 * 15,
  // 1 hour
  mediumPriorityRevalidate: 60 * 60,
  // 24 hours
  lowPriorityRevalidate: 60 * 60 * 24,
  // 60 days
  lowerPriorityRevalidate: 60 * 60 * 24 * 60,
};
